export default [
  {
    locale: "pl",
    href: "https://natu.care/pl/opinie",
  },
  {
    locale: "x-default",
    href: "https://natu.care/pl/opinie",
  },
  {
    locale: "en-GB",
    href: "https://natu.care/uk/reviews",
  },
  {
    locale: "uk",
    href: "https://natu.care/ua/vidhuky",
  },
  {
    locale: "de",
    href: "https://natu.care/de/bewertungen",
  },
  {
    locale: "cs",
    href: "https://natu.care/cz/recenze",
  },
  {
    locale: "ro",
    href: "https://natu.care/ro/opinii",
  },
  {
    locale: "hu",
    href: "https://natu.care/hu/velemenyek",
  },
  {
    locale: "sk",
    href: "https://natu.care/sk/nazory",
  },
  {
    locale: "bg",
    href: "https://natu.care/bg/pregledi",
  },
  {
    locale: "fr",
    href: "https://natu.care/fr/avis",
  },
  {
    locale: "it",
    href: "https://natu.care/it/recensioni",
  },
  {
    locale: "es",
    href: "https://natu.care/es/opiniones",
  },
  {
    locale: "nl",
    href: "https://natu.care/nl/beoordelingen",
  },
];
